//packages
import React from 'react';
import { Link } from 'react-router-dom';

//global components
import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";

// import PageNotFound from '../../_components/PageNotFound';
//services
import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
import PageNotFound from '../../_components/PageNotFound';

//styles
// import './News.sass';

class News extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {}
      },
      menu: {},
      topbarMenu: {},
      news: {},
      branches: [],
      notFound: false
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const slug = this.props.match.params[0];
    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user
      });
    } else {
      this.setState({
        user: {
          details: {}
        }
      });
    }

    Promise.allSettled([
      postService.getBySlug(slug).then(
        news => {
          if (news.length > 0) {
            this.setState({ news: news[0]})
          } else {
            this.setState({ notFound: true })
          }
        }
      ),
      menuService.getMenuByName("default").then(menu => this.setState({ menu })),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
    ]).then(() => this.setState({ loading: false }))
  }

  render() {
    const { loading, user, menu, topbarMenu, news, branches, notFound } = this.state;
 
    return (
      <>
        <PreLoader loading={loading} />
        {!notFound ?
          <>
            <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
            <div className="jumbotron page-title py-5">
              <div className="container"><h1 class="text-white">Latest News</h1></div>
            </div>
            {news &&
              <section>
                <div className="container">
                  <div className="row">
                    <div className="col-8">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-transparent m-0">
                          <li className="breadcrumb-item"><a href="/">Home</a></li>
                          <li className="breadcrumb-item "><a href="/news">News</a></li>
                          <li className="breadcrumb-item active" aria-current="page">{news.title ? news.title.rendered : ""}</li>
                        </ol>
                      </nav>

                    </div>
                    <div className="col-4 text-right">
                      <Link className="btn btn-outline-secondary mb-3" to="/news">Back to News Articles List </Link>
                    </div>

                    <div class="col-12">
                      <hr class="m-0 mb-4" />
                    </div>
                  </div>

                  {news && news.content &&
                  <div className="row mb-5">
                    <div className="col-12">
                      <h2>{news.title.rendered || ''}</h2>
                      <div className="news-content" dangerouslySetInnerHTML={{ __html: news.content.rendered }} >
                      </div>
                    </div>
                  </div>
                  }

                </div>
              </section>
             
            }
            <MainFooter menu={menu} branches={branches} />
          </>
          : <PageNotFound />
        }
      </>
    );
  }
}

export { News };